import React from 'react';
import { Input, Button, PaperClip, Select, CheckboxTable, DatePicker, Textarea } from 'components';
import { UserService, AuthService } from 'services'; // Asegúrate que AuthService esté aquí si se usa
import { Globals, Constants, Socket, SocketEvents } from 'utils';
import { WhiteImage } from 'assets/img';
import { CloseIcon, LocationIcon, TimeIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
	document_types: any;
	phonecodes: any;
	states: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			level_id: Constants.LEVELS.SELLER,
			name: '',
			email: '',
			document: '',
			address: '',
			document_type_id: this.props.document_types.length > 0 ? this.props.document_types[0].id : '',
			phonecode_id: this.props.phonecodes.length > 0 ? this.props.phonecodes[0].id : '',
			phone: '',
			web: '',
			instagram: '',
			facebook: '',
			instagram_url: '',
			facebook_url: '',
			password: '',
			password_confirmation: '',
			photo: '',          // Foto de perfil
			document_file: '',  // Foto del documento
			schedule_since: '',
			schedule_until: '',
			state_id: '',
			city_id: '',
			nit: '',
		},
		cities: []
	}

	componentDidMount() {
		if (this.props.item) {
			console.log(this.props.item)
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name,
					email: this.props.item?.email,
					document_type_id: this.props.item?.document_type_id || (this.props.document_types.length > 0 ? this.props.document_types[0].id : ''),
					phonecode_id: this.props.item?.phonecode_id || (this.props.phonecodes.length > 0 ? this.props.phonecodes[0].id : ''),
					document: this.props.item?.document || '',
					nit: this.props.item?.nit || '',
					phone: this.props.item?.phone || '',
					address: this.props.item?.address || '',
					web: this.props.item?.web || '',
					instagram: this.props.item?.instagram || '',
					facebook: this.props.item?.facebook || '',
					instagram_url: this.props.item?.instagram_url || '',
					facebook_url: this.props.item?.facebook_url || '',
					state_id: this.props.item?.state_id || '',
					city_id: this.props.item?.city_id || '',
					schedule_since: this.props.item?.schedule_since ? moment(this.props.item?.schedule_since, 'HH:mm:ss').toDate() : '',
					schedule_until: this.props.item?.schedule_until ? moment(this.props.item?.schedule_until, 'HH:mm:ss').toDate() : '',
					// Nota: Las imágenes usualmente no se cargan en el input file al editar, solo se muestran.
					// Pero mantenemos la referencia si el backend lo requiere o para validaciones visuales.
				}
			}, () => this.getCities());
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		// Preparar payload común
		const payload = {
			...this.state.form,
			hasFile: true,
			// @ts-ignore
			photo: this.state.form.photo?.value || '',
			// @ts-ignore
			document_file: this.state.form.document_file?.value || '',
			schedule_since: this.state.form.schedule_since && moment(this.state.form.schedule_since).format('HH:mm'),
			schedule_until: this.state.form.schedule_until && moment(this.state.form.schedule_until).format('HH:mm'),
		};

		if (this.props.item != null) {
			await UserService.admin.createOrUpdate({
				user_id: this.props.item?.id,
				...payload
			});
			Globals.showSuccess("Se ha modificado el vendedor correctamente");
			Socket.emit(SocketEvents.UPDATE_USER, {
				user_id: this.props.item?.id
			});
			this.props.onClose();
		}
		else {
			await UserService.admin.createOrUpdate({
				...payload
			});
			Globals.showSuccess("Se ha creado el vendedor correctamente");
			this.props.onClose();
		}
	}

	change = (e: any, callback = () => { }) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		}, callback);
	}

	getCities = async () => {
		if (!this.state.form.state_id) return;
		const res: any = await AuthService.getCities({
			state_id: this.state.form.state_id
		});
		this.setState({
			cities: res.cities
		});
	}

	render() {
		// Helper para mostrar imagen existente o previa nueva
		const getPhotoSrc = (field: any, originalProp: any) => {
			return field?.dataURL || (originalProp ? (Constants.BASE_STORAGE + originalProp) : WhiteImage);
		};

		return (
			<div id="modal-create-clinic">
				<div className="header">
					<p className="title">{!this.props.item ? 'Nuevo Vendedor' : 'Editar Vendedor'}</p>
					<button className="close" onClick={this.props.onClose}>
						<img src={CloseIcon} alt="Cerrar" />
					</button>
				</div>
				<form className="row" onSubmit={this.submit}>

					{/* SECCIÓN 1: IDENTIDAD VISUAL (FOTO DE PERFIL) */}
					{/* El backend requiere foto para crear, por eso lo descomentamos y destacamos */}
					{/* <div className="col-12 mb-3">
						<div className="container-image text-center">
							<PaperClip
								className="paperclip-image mx-auto"
								value={this.state.form.photo}
								onChange={(e: any) => {
									this.setState({
										form: { ...this.state.form, photo: e.target }
									})
								}}>
								<img
									className={`selected-image ${(this.state.form.photo || this.props.item?.photo) ? '' : 'inactive'}`}
									src={getPhotoSrc(this.state.form.photo, this.props.item?.photo)}
									alt="Perfil"
								/>
							</PaperClip>
							<p className="photo-title mt-2">Foto de Perfil o Logo</p>
						</div>
					</div> */}

					{/* SECCIÓN 2: DATOS PERSONALES */}
					<div className="col-md-12">
						<Input
							color="white"
							value={this.state.form.name}
							name="name"
							placeholder="Nombre Completo"
							label="Nombre"
							onChange={this.change} />
					</div>
					<div className="col-md-6">
						<Input
							color="white"
							value={this.state.form.email}
							name="email"
							placeholder="Correo Electrónico"
							label="Correo Electrónico"
							onChange={this.change} />
					</div>

					<div className="col-md-6">
						<div className="container-select">
							<p className="label">Teléfono</p>
							<div>
								<Select
									name="phonecode_id"
									onChange={this.change}
									value={this.state.form.phonecode_id}
									options={this.props.phonecodes.map((i: any) => ({ value: i.id, label: i.name }))} />
								<Input
									type="number"
									color="white"
									value={this.state.form.phone}
									name="phone"
									placeholder="Teléfono"
									onChange={this.change} />
							</div>
						</div>
					</div>

					{/* <div className="col-md-6">
						<div className="container-select">
							<p className="label">NIT</p>
							<div>
								<Input
									type="number"
									color="white"
									value={this.state.form.nit}
									name="nit"
									placeholder="NIT"
									onChange={this.change}
								/>
							</div>
						</div>
					</div> */}

					{/* SECCIÓN 3: UBICACIÓN */}
					<div className="col-md-6">
						<Select
							className="speciality_select"
							label="Estado"
							name="state_id"
							onChange={(e: any) => this.change(e, () => {
								this.setState({
									form: { ...this.state.form, city_id: '' }
								}, () => this.getCities());
							})}
							value={this.state.form.state_id}
							options={this.props.states.map((i: any) => ({ value: i.id, label: i.name }))} />
					</div>
					<div className="col-md-6">
						<Select
							className="speciality_select"
							label="Ciudad"
							disabled={!this.state.form.state_id}
							name="city_id"
							onChange={this.change}
							value={this.state.form.city_id}
							options={this.state.cities.map((i: any) => ({ value: i.id, label: i.name }))} />
					</div>

					

					{/* SECCIÓN 4: DATOS LEGALES (AQUÍ ESTÁ EL CAMBIO SOLICITADO) */}
					{/* Agrupamos inputs legales a la izquierda y el archivo a la derecha para mejor UX */}

					<div className="col-md-6">
						<div className="row">
							<div className="col-12">
								<p className="section-subtitle" style={{ color: 'white', marginBottom: '15px', fontWeight: 'bold' }}>Información Legal</p>
							</div>
							<div className="col-12">
								<div className="container-select">
									<p className="label">Cédula/RIF</p>
									<div>
										<Select
											className="document_type"
											name="document_type_id"
											onChange={this.change}
											value={this.state.form.document_type_id}
											options={this.props.document_types.map((i: any) => ({ value: i.id, label: i.name }))} />
										<Input
											type="number"
											color="white"
											value={this.state.form.document}
											name="document"
											placeholder="Nro. Documento"
											onChange={this.change} />
									</div>
								</div>
							</div>
							
						</div>
					</div>

					<div className="col-md-5 d-flex align-items-center justify-content-center">
						{/* INPUT PARA DOCUMENTO ADJUNTO - AL LADO DE LOS DATOS */}
						<div className="container-image text-center" style={{ marginTop: '25px' }}>
							<PaperClip
								className="paperclip-image"
								value={this.state.form.document_file}
								onChange={(e: any) => {
									this.setState({
										form: { ...this.state.form, document_file: e.target }
									})
								}}>
								<img
									className={`selected-image ${(this.state.form.document_file || this.props.item?.document_file) ? '' : 'inactive'}`}
									src={getPhotoSrc(this.state.form.document_file, this.props.item?.document_file)}
									alt="Doc"
									style={{ objectFit: 'contain' }} // Asegura que el documento se vea completo
								/>
							</PaperClip>
							<p className="photo-title mt-2">Adjuntar Cédula / RIF</p>
							<small style={{ color: '#999', fontSize: '0.8em' }}>Formato imagen (JPG, PNG)</small>
						</div>
					</div>

					<div className="col-12"><hr className="separator-line" style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} /></div>

					{this.props.item && (
						<>
							<p className="mt-4 mb-0"><strong>Datos bancarios</strong></p>
							<div className="col-12 mb-4">
								<div className="row border border-success" style={{ borderRadius: "10px" }}>

									<div className="col-4 bg-ctl p-2 border border-success" style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px" }}>
										<h6 className="text-ct" style={{ fontWeight: "bold" }}>{this.props.item.bank_account?.bank?.name}</h6>
										<p>{this.props.item.bank_account?.number}</p>
									</div>

									<div className="col-4 bg-ctl p-2 border border-success">
										<h6 className="text-ct" style={{ fontWeight: "bold" }}>Cédula</h6>
										<p>{this.props.item.bank_account?.document_format}</p>
									</div>

									<div className="col-4 bg-ctl p-2 border border-success" style={{ borderTopRightRadius: "10px", borderBottomRightRadius: "10px" }}>
										<h6 className="text-ct" style={{ fontWeight: "bold" }}>Teléfono</h6>
										<p>{this.props.item.bank_account?.phone_format}</p>
									</div>

								</div>
							</div>
						</>
					)}

					{/* SECCIÓN 5: SEGURIDAD */}
					<div className="col-md-6">
						<Input
							type="password"
							color="white"
							value={this.state.form.password}
							name="password"
							placeholder="Contraseña"
							label="Contraseña"
							onChange={this.change} />
					</div>
					<div className="col-md-6">
						<Input
							type="password"
							color="white"
							value={this.state.form.password_confirmation}
							name="password_confirmation"
							placeholder="Repetir Contraseña"
							label="Repetir Contraseña"
							onChange={this.change} />
					</div>

					<div className="col-12 mt-4">
						<div className="row row-buttons">
							<div className="col-md-6 text-center">
								<Button type="button" onClick={() => this.props.onClose()}>
									Cerrar
								</Button>
							</div>
							<div className="col-md-6 text-center">
								<Button type="submit">
									Guardar
								</Button>
							</div>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;